var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgBell = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4104 11.2705C13.0621 10.1045 11.8143 8.45933 11.8143 4.3519C11.8143 1.97317 9.87906 0.0379505 7.50026 0.0379505C5.12114 0.0379505 3.1856 1.97317 3.1856 4.3519C3.1856 8.46306 1.93829 10.1066 0.588777 11.2716C0.214624 11.5975 0 12.0668 0 12.5592C0 12.8303 0.219728 13.05 0.490756 13.05H5.14803C5.37522 14.1403 6.34339 14.9621 7.5 14.9621C8.65661 14.9621 9.62484 14.1404 9.85197 13.05H14.5092C14.7803 13.05 15 12.8303 15 12.5592C15 12.0628 14.7849 11.5928 14.4104 11.2705ZM7.5 13.9806C6.88884 13.9806 6.36661 13.5926 6.16639 13.05H8.83361C8.63338 13.5926 8.11115 13.9806 7.5 13.9806ZM1.17481 12.0685C1.19267 12.0491 1.21171 12.0307 1.2318 12.0132C3.28925 10.2369 4.16704 7.94567 4.16704 4.3519C4.16704 2.51437 5.66235 1.01946 7.5002 1.01946C9.33778 1.01946 10.8328 2.51437 10.8328 4.3519C10.8328 7.9424 11.7107 10.2336 13.7692 12.0136C13.7893 12.031 13.8083 12.0492 13.8262 12.0685H1.17481Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBell, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bell.fc3a025d.svg";
export { ForwardRef as ReactComponent };